import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TypeProgramComparisonTableSkeleton } from "./TypeProgramComparisonTable";
import type { TypeTableOfContentsSettingSkeleton } from "./TypeTableOfContentsSetting";

/**
 * Fields type definition for content type 'TypeProgramComparisonSection'
 * @name TypeProgramComparisonSectionFields
 * @type {TypeProgramComparisonSectionFields}
 * @memberof TypeProgramComparisonSection
 */
export interface TypeProgramComparisonSectionFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'header' (Header)
     * @name Header
     * @localized false
     */
    header: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'comparisonTables' (Comparison Tables)
     * @name Comparison Tables
     * @localized false
     */
    comparisonTables: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeProgramComparisonTableSkeleton>>;
    /**
     * Field type definition for field 'backgroundColor' (Background Color)
     * @name Background Color
     * @localized false
     */
    backgroundColor?: EntryFieldTypes.Symbol<"grey" | "light-blue" | "white">;
    /**
     * Field type definition for field 'tocSetting' (tocSetting)
     * @name tocSetting
     * @localized false
     */
    tocSetting?: EntryFieldTypes.EntryLink<TypeTableOfContentsSettingSkeleton>;
}

/**
 * Entry skeleton type definition for content type 'programComparisonSection' (Program Comparison Section)
 * @name TypeProgramComparisonSectionSkeleton
 * @type {TypeProgramComparisonSectionSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-24T20:44:05.472Z
 * @version 7
 */
export type TypeProgramComparisonSectionSkeleton = EntrySkeletonType<TypeProgramComparisonSectionFields, "programComparisonSection">;
/**
 * Entry type definition for content type 'programComparisonSection' (Program Comparison Section)
 * @name TypeProgramComparisonSection
 * @type {TypeProgramComparisonSection}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-24T20:44:05.472Z
 * @version 7
 */
export type TypeProgramComparisonSection<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeProgramComparisonSectionSkeleton, Modifiers, Locales>;

export function isTypeProgramComparisonSection<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeProgramComparisonSection<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'programComparisonSection'
}
